<main>
  <h1 class="dissatisfied-title">{{ title | translate }}</h1>
  <div class="dissatisfied-row">
    <mat-icon>sentiment_very_dissatisfied</mat-icon>
  </div>
  <div class="dissatisfied-description">
    <span>{{ description | translate }}</span>
  </div>
</main>
